/**
* Web Service handler to retrieve and represent a list of queues at a location
*
* @class QueuesWS
*/
var QueuesWS = function (parent) {
  var self = this; // Convenience reference so the context of 'this' becomes clearer

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self.allQueues = ko.observableArray([]);	// Collection of all queues at all locations
  self.locationIds = ko.observableArray([]);		// The location ID to get queues for
  self.locationCount = 0;						// The number of locations to load queues for
  self.name = 'QueuesWS';				// Convenience name for debugging
  self.processedCount = 0;						// The number of location's queues processed
  self.queues = ko.observableArray([]);	// Collection of available queues
  self.indexedQueues = ko.observable(null);
  self.allowResourceSelection = ko.observable(null);
  self.kioskQueueWS = new KioskQueuesWS(self);


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/locations/' + self.locationIds().join(',') + '/queues';
  }, self, { deferEvaluation: true });



	/**
	* This computed observable allows the TransactionTypesWS to build a URL
	* with the list of known appointment-enabled Queue Ids
	*
	* @method allQueueIds
	* @return {Array} array of queue ids
	*/
  self.allQueueIds = ko.computed(function () {
    var i = 0, 	// Standard increment
      aQueueIds = [];

    for (i = 0; i < self.queues().length; i++) {
      aQueueIds.push(self.queues()[i].id);
    }

    return aQueueIds;
  }, self, { deferEvaluation: true });


	/**
	* Requests data from the API service
	*
	* @method doRequest
	* @return none
	*/
  self.doRequest = function () {
    qcal.setStatusMessage('Requesting queues');

    AbstractWS.prototype.doRequest.apply(self, arguments);
  };


	/**
	* This method iterates over the data returned from the service and
	* converts the individual nodes into QueueModels and then assigns
	* them to this object's queues collection.
	*
	* @method processData
	* @param {XMLString} xmlData XML data returned from the service
	* @return {QueuesWS} Returns the object as chainable, for best practice
	*/
  self.processData = function (xmlData) {
    var aQueues = [],			// A collection of jQuery matched nodes
      i = 0,					// Standard increment
      queueModel = null,		// Instance of QueueModel created from data
      tempQueues = [],
      tempAllQueues = [];

    qcal.setStatusMessage('Queues received', 1000);

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    // Use jQuery's find method to return a collection of nodes that
    // match the 'queue' tag
    var aQueues = $(xmlData).find('queue');
    var tIdxQueues = {};

    for (i = 0; i < aQueues.length; i++) {
      // Create a new QueueModel object with the data node
      // and add it to the locations collection

      queueModel = new QueueModel(aQueues[i]);

      tempAllQueues.push(queueModel);
      tIdxQueues[queueModel.id] = queueModel;

      if (queueModel.appointmentsEnabled == true) {
        tempQueues.push(queueModel);
      }
    }

    self.allQueues(tempAllQueues);
    self.queues(tempQueues);
    self.indexedQueues(tIdxQueues);

    // Now that queues have been loaded, call the callbackHandler
    qcal.callbackQueuesLoaded();

    // Return self (QueuesWS) to be chainable, for best practice
    return self;
  };

  return self;
};

QueuesWS.prototype = Object.create(AbstractWS.prototype);
QueuesWS.prototype.constructor = QueuesWS;

/**
 * @method getQueue
 * @param {Number|String} queueId
 * @return {QueueModel|undefined}
 */
QueuesWS.prototype.getQueue = function (queueId) {
  return this.indexedQueues()[queueId.toString()]
}

/**
 * Get Queues for the specified Location
 * @param {String} id
 * @returns
 */
QueuesWS.prototype.getQueuesByLocationId = function (id) {
    return this.queues().reduce(function (locationQueues, q) {
      if (q.locationId == id) {
        locationQueues.push({
          'id': q.id,
          'description': q.description
        });
      }
      return locationQueues;
    }, []);
}


if (typeof exports !== "undefined") {
  exports.QueuesWS = QueuesWS;
}
